// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-info[data-v-bb5f9a8c] {\n  background: #f7f7f7 0% 0% no-repeat padding-box;\n  border-radius: 5px;\n  opacity: 1;\n  border-left-style: solid;\n  border-color: #e8e8e8;\n  border-width: 0;\n}\n.no-info .no-info-text[data-v-bb5f9a8c] {\n  text-align: left;\n  font: Bold 16px/22px Lato;\n  letter-spacing: 0;\n  color: #727272;\n  opacity: 1;\n}\n.no-info .no-info-icon[data-v-bb5f9a8c] {\n  color: #727272;\n  font-size: 32px;\n}", ""]);
// Exports
module.exports = exports;
